var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Enroll in the Course")]),_c('p',[_vm._v("Enroll now to start your journey in affiliate marketing.")])])
}]

export { render, staticRenderFns }